import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink } from 'apollo-link';
import { onError } from 'apollo-link-error';
import { cacheInit } from './ApolloCache';
import { toast } from 'react-toastify';
import ThomasAuthService from 'services/ThomasAuth/ThomasAuthService';
import { Auth } from 'aws-amplify';

const auth = new ThomasAuthService();

const cache = new InMemoryCache({
  dataIdFromObject: object => object.id || null,
  addTypename: false
});

cacheInit(cache);

const uri = process.env.REACT_APP_GRAPHQL_ENDPOINT;

const httpLink = createHttpLink({
  uri: uri
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  //console.log({ description: `Starting errorLink.`, graphQLErrors, networkError });

  if (networkError) {
    console.log(`network error`, networkError);
    if (networkError.message.includes('403')) {
      // fail cognito auth session
      // missing token
      auth.logout('/');
      window.location.href = process.env.REACT_APP_BASE_URL_PATH + '/login';
    } else if (networkError.message.includes('401')) {
      // success session missing claims
      // auth.logout('/');
      window.location.href = process.env.REACT_APP_BASE_URL_PATH + '/noauthorized';
    } else if (networkError.message.includes('409')) {
      // missing claims for specific tgrams
      // auth.logout('/');
      window.location.href = process.env.REACT_APP_BASE_URL_PATH + '/error';
    }
    toast.error('Something went wrong!');
  }
  if (graphQLErrors) {
    toast.error('Something went wrong!');
    console.log(`graph error`, graphQLErrors);
  }
});

const authLink = setContext(
  request =>
    new Promise((resolve, reject) => {
      //console.log({ description: `Starting authlink` });

      Auth.currentSession()
        .then((session: any) => {
          // console.log({ description: `Resolving authlink` });
          const token = session.idToken.jwtToken;
          resolve({
            headers: { Authorization: token }
          });
        })
        .catch(err => {
          console.log({ description: `Auth.currentSession error.`, error: err });
          const search = window.location.search;
          const params = new URLSearchParams(search);
          const token = params.get('token');
          if (token !== '') {
            resolve({
              headers: { Authorization: token }
            });
          }
          resolve({});
        });
    })
);

// const authLink = setContext(request => new Promise((resolve, reject) => {
//   Auth.currentSession()
//   .then((session:any) => {
//     const token = session.idToken.jwtToken;
//     console.log(`token`, token);
//     resolve({
//       headers: { Authorization: token },
//     });
//   }).catch((err) => {
//     console.log("error1:", err);
//     reject(err);
//   });
// }));

export const client = new ApolloClient({
  cache,
  link: ApolloLink.from([authLink, errorLink, httpLink]),
  resolvers: {}
});
